module.exports = __webpack_public_path__ + "img/plus.139df48f.svg";